module.exports = __webpack_public_path__ + "static/media/zennwannhineri.dfdf9055.png";